import React, { useState, useEffect, useRef, Fragment } from "react";
import { Link, useNavigate } from "react-router";
import { IDomain } from "../../../model/interface/domain";
import Pagination from "../../shared/common/pagination";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import DeleteModal from "../../shared/common/deleteModal";
import Loader from "../../shared/loader/loader";
import Select from "react-select";
import {
  AddIcon,
  FilterIcon,
  EditIcon,
  DeleteIcon,
  ResetIcon,
  CaretUpSolidIcon,
  CaretDownSolidIcon,
  ApproveIcon,
  Disapprove,
  CSVIcon,
} from "../../../assets/icons/index";
import constant from "../../../utils/constant";
import { getStateAll, getSubject } from "../../../api/subject.service";
import { ISubjectPage } from "../../../model/interface/subject";
import { ISelectElement } from "../../../model/interface/keyValuePair";
import ExportToCSV from "../../shared/common/exportToCsv";
import { DotsVerticalIcon } from "@heroicons/react/solid";
import { Menu, Transition } from "@headlessui/react";
import { toast } from "react-toastify";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Domain: React.FC = () => {
  const defaultPageNumber = 1;
  const defaultPageSize = 100;
  const defaultObject: ISelectElement = { label: "", value: "0" };
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [newDomain, setNewDomain] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [deleteDomain, setDeleteDomain] = useState<number>(0);
  const [subjectId, setSubjectId] = useState<any>("");
  const [name, setName] = useState<string>("");
  const [orderByColumn, setOrderByColumn] = useState<string>("name");
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [sortByDesc, setSortByDesc] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [selectedSubject, setselectedSubject] =
    useState<ISelectElement>(defaultObject);
  const [subjects, setSubjects] = useState<ISelectElement>();
  const [selectedState, setSelectedState] =
    useState<ISelectElement>(defaultObject);
  const [states, setStatesData] = useState<ISelectElement[]>([defaultObject]);
  const navigate = useNavigate();
  const [domainId, setDomainId] = useState<number>(0);
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isFilter, setIsFilter] = useState<boolean>(false);
  const childRef: any = useRef(undefined);
  const [active, setActive] = useState<boolean>(false);
  const [inactive, setInactive] = useState<boolean>(false);
  const [inactiveActive, setInactiveActive] = useState<boolean>(true);

  const deleteDomainHandler = (e, id) => {
    e.preventDefault();
    setShowDeleteModal(true);
    setDeleteDomain(id);
  };

  const deleteRecordHandler = async () => {
    const service = await import("../../../api/domain.service");
    const result = (await service.deleteDomaincontent(deleteDomain)).data;
    setDeleteDomain(0);

    if (result.status === "Error") {
      toast.warning(result.message);
      bindDomain();
      setShowDeleteModal(false);
    } else {
      toast.success("Deleted Successfully");
      bindDomain();
      setShowDeleteModal(false);
    }
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleRedirect = (domain?: IDomain) => {
    navigate(
      domain
        ? constant.EDITDOMAIN.replace(":id", domain.domainId.toString())
        : constant.ADDDOMAIN,
      { state: { objectToEdit: domain } }
    );
  };

  const handleSortBy = (column: string) => {
    setSortByDesc(!sortByDesc);
    setOrderByColumn(column);
  };

  const filterSubjectChangeHandler = (e) => {
    setSubjectId(e.value);
    setselectedSubject(e);
  };

  const filterHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    setIsFilter(true);
    const domain: any = {
      name: name === "" ? "" : name,
      subjectId: subjectId === "" ? "0" : subjectId,
      orderByColumn: orderByColumn,
      sortByDesc: !sortByDesc ? "ASC" : "DESC",
      pageSize: defaultPageSize,
      pageNumber: defaultPageNumber,
      isActive: active,
      inactiveActive: inactiveActive,
      domainId: domainId,
      stateId: selectedState?.value,
    };
    const service = await import("../../../api/domain.service");
    service.getDomainAll(domain).then((response: any) => {
      setNewDomain(response.data.data);
      setTotalPages(Math.ceil(response.data.totalRecords / defaultPageSize));
      setTotalRows(response.data.totalRecords);
      setLoading(false);
      paginationRef?.current?.onReset();
      pageSizeRef?.current?.onReset();
      setIsFilter(false);
    });
  };

  const bindDomain = async (isReset?) => {
    setLoading(true);

    const domain = {
      name: isReset ? "" : name ? name : "",
      subjectId: isReset ? 0 : subjectId ? subjectId : 0,
      orderByColumn: orderByColumn,
      sortByDesc: !sortByDesc ? "ASC" : "DESC",
      pageSize: isReset ? defaultPageSize : pageSize,
      pageNumber: isReset ? defaultPageNumber : pageNumber,
      isActive: active,
      inactiveActive: inactiveActive,
      domainId: isReset ? 0 : domainId ? domainId : 0,
      stateId: isReset ? 0 : selectedState?.value ? selectedState?.value : 0,
    };

    const service = await import("../../../api/domain.service");
    service.getDomainAll(domain).then((response: any) => {
      setNewDomain(response.data.data);
      setTotalRows(response.data.totalRecords);
      setTotalPages(
        Math.ceil(
          response.data.totalRecords / (isReset ? defaultPageSize : pageSize)
        )
      );
      setLoading(false);
    });
  };

  const resetClickHandler = () => {
    setResetDropdownFlag(!resetDropdownFlag);
    setTimeout(() => {
      setResetDropdownFlag(false);
    }, 1500);
    setSelectedState(defaultObject);
    setselectedSubject(defaultObject);
    setName("");
    setDomainId(0);
    setSubjectId("");
    bindDomain(true);
    setInactiveActive(true);
    setInactive(false);
    setActive(false);
    paginationRef?.current?.onReset();
    pageSizeRef?.current?.onReset();
  };

  useEffect(() => {
    if (isLoaded) {
      bindDomain();
    }
  }, [sortByDesc]);

  useEffect(() => {
    if (isLoaded && !isFilter) {
      bindDomain();
      getStateData();
    }
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1 && !isFilter) {
      bindDomain();
      getStateData();
      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  const getStateData = async () => {
    const response = getStateAll(999, 1);
    const data = (await response).data;
    let newStateData: ISelectElement[] = [];
    if (data.data.length > 0) {
      newStateData = data.data.map((st) => {
        return {
          value: st.stateId || 0,
          label: `${st.name}`,
        };
      });
    }
    setStatesData(newStateData);
  };

  function filterStateChangeHandler(e) {
    setSelectedState(e);
    setLoading(true);
    const subjectData: ISubjectPage = {
      name: "",
      contentAreaId: 0,
      stateId: e.value || 0,
      gradeId: 0,
      gradeLevel: "",
      orderbyColumn: "name",
      sortDir: sortByDesc ? "desc" : "asc",
      pageSize: 999,
      pageNumber: 1,
      isActive: true,
    };

    getSubject(subjectData).then((response: any) => {
      const result = response.data.data;
      const dropdownData = result.map((item) => {
        return { label: item.name, value: item.subjectId };
      });
      setSubjects(dropdownData);
      setLoading(false);
    });
  }

  /** Code to implement input type number to support all browsers */
  useEffect(() => {
    const input = document.getElementById("domainId");
    if (input) {
      input.addEventListener("keypress", (e: any) => {
        const keyValue = e.key;
        if (!e.target.value && e.key == 0) {
          e.preventDefault();
        } else {
          if (!/[0-9.]/.test(keyValue)) {
            e.preventDefault();
          }
        }
      });
    }
  }, []);

  const exportFn = async () => {
    setLoading(true);
    const domain: any = {
      name: name === "" ? "" : name,
      subjectId: subjectId === "" ? "0" : subjectId,
      orderByColumn: orderByColumn,
      sortByDesc: !sortByDesc ? "ASC" : "DESC",
      pageSize: defaultPageSize,
      pageNumber: defaultPageNumber,
      isApproved: true,
      domainId: domainId,
      stateId: selectedState?.value,
      inactiveActive: inactiveActive,
    };

    const service = await import("../../../api/domain.service");
    const response = service.getDomainExport(domain);
    const data = await response;
    setLoading(false);

    if (data && data?.data?.length > 0) {
      childRef?.current?.onDownload(data.data, "domains.csv");
    } else {
      toast.warning("No records to download");
    }
  };
  const toggleIsActive = (tab: string) => {
    if (tab === "Active") {
      setActive(true);
      setInactive(false);
      setInactiveActive(false);
    } else if (tab === "Inactive") {
      setActive(false);
      setInactive(true);
      setInactiveActive(false);
    } else {
      setActive(false);
      setInactive(false);
      setInactiveActive(true);
    }
  };

  return (
    <AllowedTo perform={Permissions.domain_view} no={() => <AccessDenied />}>
      {loading && <Loader />}

      {showDeleteModal && (
        <DeleteModal
          closeDeleteModal={closeDeleteModal}
          deleteRecord={deleteRecordHandler}
        />
      )}

      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">Domain</h3>
              <AllowedTo perform={Permissions.domain_create}>
                <button
                  type="button"
                  className="inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transition ease-in-out duration-300"
                  onClick={() => handleRedirect()}
                >
                  <AddIcon className="w-5"></AddIcon>
                  Add Domain
                </button>
              </AllowedTo>
            </div>
            <form action="#" onSubmit={filterHandler}>
              <div className="pt-6 border-b pb-6">
                <div className="grid  grid-cols-12 gap-6">
                  <div className="col-span-3 sm:col-span-3">
                    <label className="text-sm text-gray-700">Domain Id</label>
                    <div className="contentArea">
                      <input
                        id="domainId"
                        name="domainId"
                        type="text"
                        autoComplete="off"
                        className="w-full mt-1 block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                        value={domainId || ""}
                        onChange={(e) => {
                          setDomainId(Number(e.target.value));
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-span-3 sm:col-span-3">
                    <label className="text-sm text-gray-700">Name</label>
                    <div className="contentArea">
                      <input
                        id="name"
                        name="name"
                        type="text"
                        autoComplete="off"
                        className="w-full mt-1 block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-span-3 sm:col-span-3">
                    <label className="text-sm text-gray-700">State</label>
                    <div
                      id="stateDropDown"
                      className="items-center contentArea mt-1"
                    >
                      <Select
                        options={states}
                        value={selectedState}
                        isMulti={false}
                        onChange={(e) => {
                          filterStateChangeHandler(e);
                        }}
                      ></Select>
                    </div>
                  </div>
                  <div className="col-span-3 sm:col-span-3">
                    <label className="text-sm text-gray-700">Subject</label>
                    <div className="items-center contentArea mt-1">
                      <Select
                        options={
                          [
                            {
                              value: subjects?.value.toString(),
                              label: subjects?.label,
                            } as ISelectElement,
                          ] || []
                        }
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                        value={selectedSubject}
                        onChange={filterSubjectChangeHandler}
                        className=""
                      />
                    </div>
                  </div>
                </div>

                <div className="col-span-3 flex items-center mt-6 mb-4">
                  <div className="flex items-end mt-6 justify-end">
                    <div className="inline-block border text-sm border-gray-300 overflow-hidden rounded-md">
                      <span
                        onClick={() => toggleIsActive("Active")}
                        className={`${
                          active
                            ? "bg-primary-color text-white"
                            : "bg-white text-gray-400"
                        } inline-block dark:text-white py-0.5 px-2 text-sm  text-center cursor-pointer hover:opacity-80`}
                      >
                        Active
                      </span>
                      <span
                        onClick={() => toggleIsActive("all")}
                        className={`${
                          inactiveActive
                            ? "bg-primary-color text-white"
                            : "bg-white text-gray-400"
                        } py-0.5 px-2 inline-block text-center text-sm  cursor-pointer hover:text-gray-500 dark:hover:text-gray-400`}
                      >
                        Both
                      </span>
                      <span
                        onClick={() => toggleIsActive("Inactive")}
                        className={`${
                          inactive
                            ? "bg-primary-color text-white"
                            : "bg-white text-gray-400"
                        } py-0.5 px-2 inline-block text-center text-sm  cursor-pointer hover:text-gray-500 dark:hover:text-gray-400`}
                      >
                        Inactive
                      </span>
                    </div>
                  </div>
                </div>

                <div className="flex justify-start">
                  <button
                    type="submit"
                    className="inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg mt-4"
                  >
                    <FilterIcon className="w-3"></FilterIcon>
                    <span>Filter</span>
                  </button>
                  <button
                    type="button"
                    onClick={resetClickHandler}
                    className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                  >
                    <ResetIcon className="w-3 h-3"></ResetIcon>
                    <span>Reset Filter</span>
                  </button>
                </div>
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => exportFn()}
                  className="mt-4 py-1.5 px-4 inline-flex ml-auto items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                >
                  <CSVIcon className="w-3 h-3 dark:text-white stroke-current"></CSVIcon>
                  <span>Export</span>
                </button>
                <ExportToCSV ref={childRef} />
              </div>
            </form>

            <div id="dataContainer" className="mt-4">
              <div className="flex flex-col mt-1">
                <div className="-my-2  sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow border-b border-gray-200 sm:rounded-lg">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-primary-color">
                          <tr>
                            <th
                              scope="col"
                              className="px-5 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider rounded-tl-lg"
                            >
                              <span className="flex ">
                                Id
                                <span className="cursor-pointer">
                                  {sortByDesc &&
                                  orderByColumn === "domainId" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("domainId")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("domainId")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex ">
                                Name
                                <span className="cursor-pointer">
                                  {sortByDesc && orderByColumn === "name" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("name")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("name")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Subject
                                <span className="cursor-pointer">
                                  {sortByDesc && orderByColumn === "subject" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("subject")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("subject")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span>Test Percentage</span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span>Load Order</span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex gap-2">
                                Source Type
                                {sortByDesc &&
                                orderByColumn === "sourceType" ? (
                                  <CaretUpSolidIcon
                                    onClick={() => handleSortBy("sourceType")}
                                    className="w-5 h-5"
                                  ></CaretUpSolidIcon>
                                ) : (
                                  <CaretDownSolidIcon
                                    onClick={() => handleSortBy("sourceType")}
                                    className="w-5 h-5"
                                  ></CaretDownSolidIcon>
                                )}
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider rounded-tr-lg"
                            ></th>
                          </tr>
                        </thead>
                        <tbody>
                          {newDomain.map((domain, index) => (
                            <tr
                              key={index}
                              className={
                                index % 2 === 0 ? "bg-white" : "bg-gray-100"
                              }
                            >
                              <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500 relative">
                                {domain.isActive ? (
                                  <span className="mr-1 h-4/5 w-0.5 bg-green-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                ) : (
                                  <span className="mr-1 h-4/5 w-0.5 bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                )}
                                <Link
                                  to={constant.EDITDOMAIN.replace(
                                    ":id",
                                    domain.domainId.toString()
                                  )}
                                  className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                >
                                  {domain.domainId}
                                </Link>
                              </td>
                              <td className="px-3 py-2 break-normal text-sm text-left font-normal text-gray-500">
                                <a
                                  href={constant.EDITDOMAIN.replace(
                                    ":id",
                                    domain.domainId.toString()
                                  )}
                                  className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                >
                                  {domain.name}
                                </a>
                              </td>
                              <td className="px-3 py-2 text-sm text-left font-normal text-gray-500">
                                <Link
                                  className="font-medium text-indigo-600 cursor-pointer hover:text-indigo-500 hover:underline"
                                  to={constant.SUBJECTDETAIL.replace(
                                    ":id",
                                    domain.subjectId
                                      ? domain.subjectId.toString()
                                      : ""
                                  )}
                                  state={{ subjectType: 1 }}
                                >
                                  {domain.subjectName}
                                </Link>
                              </td>
                              <td className="px-3 py-2  text-sm text-center font-normal text-gray-500">
                                {domain.testPercentage}
                              </td>
                              <td className="px-3 py-2  text-sm text-center font-normal text-gray-500">
                                {domain.loadOrder}
                              </td>
                              <td className="px-3 py-2  text-sm text-left font-normal text-gray-500">
                                {domain.sourceType}
                              </td>

                              <td className="flex justify-end items-center px-3 py-2  text-sm text-center font-normal text-gray-700">
                                <div className="flex justify-center items-center space-x-2 ">
                                  {domain.isApproved ? (
                                    <ApproveIcon title="Approved" />
                                  ) : (
                                    <Disapprove />
                                  )}

                                  <Menu
                                    as="div"
                                    className="relative flex justify-end items-center"
                                  >
                                    <Menu.Button className="h-7 bg-white inline-flex items-center justify-center text-gray-400 rounded-full hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bg-primary-color">
                                      <DotsVerticalIcon
                                        className="w-5 h-5"
                                        aria-hidden="true"
                                      />
                                    </Menu.Button>
                                    <Transition
                                      as={Fragment}
                                      enter="transition ease-out duration-100"
                                      enterFrom="transform opacity-0 scale-95"
                                      enterTo="transform opacity-100 scale-100"
                                      leave="transition ease-in duration-75"
                                      leaveFrom="transform opacity-100 scale-100"
                                      leaveTo="transform opacity-0 scale-95"
                                    >
                                      <Menu.Items className="mx-3 origin-top-right absolute right-7 top-0 w-48 mt-1 rounded-md shadow-lg z-10 bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 focus:outline-none">
                                        <div className="py-1">
                                          <AllowedTo
                                            perform={Permissions.domain_modify}
                                          >
                                            <Menu.Item>
                                              {({ active }) => (
                                                <a
                                                  onClick={() =>
                                                    handleRedirect(domain)
                                                  }
                                                  className={classNames(
                                                    active
                                                      ? "bg-gray-100 text-gray-900"
                                                      : "text-gray-700",
                                                    "group flex items-center px-4 py-2 text-sm"
                                                  )}
                                                >
                                                  <EditIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300" />
                                                  Edit
                                                </a>
                                              )}
                                            </Menu.Item>
                                          </AllowedTo>
                                        </div>
                                        <AllowedTo
                                          perform={Permissions.domain_delete}
                                        >
                                          <div className="py-1">
                                            <Menu.Item>
                                              {({ active }) => (
                                                <a
                                                  onClick={(e) =>
                                                    deleteDomainHandler(
                                                      e,
                                                      domain.domainId
                                                    )
                                                  }
                                                  className={classNames(
                                                    active
                                                      ? "bg-gray-100 text-gray-900"
                                                      : "text-gray-700",
                                                    "group flex items-center px-4 py-2 text-sm"
                                                  )}
                                                >
                                                  <DeleteIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300" />
                                                  Delete
                                                </a>
                                              )}
                                            </Menu.Item>
                                          </div>
                                        </AllowedTo>
                                      </Menu.Items>
                                    </Transition>
                                  </Menu>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div
                  className={`flex justify-between items-center ${
                    newDomain.length === 0 ? "hidden" : ""
                  }`}
                >
                  <Pagination
                    pages={totalPages}
                    setPageNumber={setPageNumber}
                    ref={paginationRef}
                  />
                  <span>
                    <span className="text-sm pr-4 ml-auto text-left-700">
                      Showing {pageNumber} to{" "}
                      {totalRows < pageSize ? totalRows : pageSize} of{" "}
                      {totalRows} results
                    </span>
                    <SelectPageSize
                      setPageSize={setPageSize}
                      type={"second"}
                      ref={pageSizeRef}
                      defaultPage={defaultPageSize}
                    />
                  </span>
                </div>

                {newDomain.length === 0 && (
                  <p className="p-2">No Records Found</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};

export default Domain;
